import ahoy from 'ahoy.js';

// Initialize Ahoy tracking
window.ahoy = ahoy;
ahoy.configure({ cookies: true });
ahoy.trackView(); 